<script>
    import {nextTick} from "vue";
    import {Listeners} from "../../../constants/listeners";
    import ActionsContainer from "./actions-container.vue";
    import Button from "primevue/button";

    export default {
        data() {
            return {
                rollUp: false,
                style: {},
                selectedTo: [],
            }
        },
        mounted: function () {
            this.$emitter.on(Listeners.KS_TABLE_CHECKBOX_SELECTED, eventData => this.selectedTo = eventData);
        },

        methods: {
            openTools(){
                let ids = this.selectedTo.slice();

                this.openTab("/" + window.locale + "/tools/dictionary-by-pages?ids=" + ids.join());
            },
            openTab(url){
                window.open(url, '_blank');
            },
            clearSelectedTo(){
                this.$emitter.emit(Listeners.KS_TABLE_CLEAR_SELECTED_TO);
            },
            handleScroll(){

                if(document.getElementsByClassName('ks-button-panel').length === 0){
                    return;
                }

                let table = document.getElementsByClassName('vuetable')[0],
                    panel = document.getElementsByClassName('ks-button-panel')[0];

                if((window.innerHeight - 200) >= (table.getBoundingClientRect().height + table.getBoundingClientRect().top + 70)){
                    this.style = {
                        top: (table.getBoundingClientRect().height + table.getBoundingClientRect().top + 70) + 'px',
                    }
                }else{
                    this.style = {
                        top: (window.innerHeight - 200) + 'px'
                    };
                }
            }


        },
        computed: {
            panelStyle(){
                return Object.assign({}, this.style, this.rollUp?{padding: '15px', opacity: 0.5}:{});
            },

        },
        watch: {
            selectedTo: function (val) {
                let self = this;
                nextTick(() => {
                    self.handleScroll();
                });

            }
        },

        created: function () {
            window.addEventListener('scroll', this.handleScroll);
            this.handleScroll();

        },
        destroyed: function () {
            window.removeEventListener('scroll', this.handleScroll);
        },
        components: {
            ActionsContainer,
            Button,
        }
    }
</script>

<template>
    <ActionsContainer :panelStyle="panelStyle" :selectedCount="selectedTo.length">
        <template #buttons>
            <Button @click="openTools" :label="$t('lang.main.table.components.conc_pages_action.dictionary_by_pages')" size="small" />
            <Button @click="clearSelectedTo" :label="$t('lang.main.btn.clear')" severity="secondary" size="small" />
        </template>
    </ActionsContainer>
</template>
